/* @big-data/react-forge v1.1.6 by leo */
'use strict';

var get = require('lodash/get.js');
var axios = require('axios');

/**
 * @Author  : zhouming
 * @页面名称    :依赖宿主环境的 habo 进行上报
 * @页面描述    :
 */
var HostHabo = /** @class */ (function () {
    function HostHabo() {
    }
    Object.defineProperty(HostHabo, "habo", {
        get: function () {
            if (window.habo) {
                return window.habo;
            }
            return {
                time: function () { },
                timeEnd: function () { },
            };
        },
        enumerable: false,
        configurable: true
    });
    HostHabo.time = function (key) {
        HostHabo.habo.time(key);
    };
    HostHabo.timeEnd = function (key) {
        HostHabo.habo.timeEnd(key);
    };
    return HostHabo;
}());

/**
 * @description: 计算字符串 hash 值
 * 哈希函数法
 */
var hash = function (strParams) {
    // 初始化 hash 为 5381。
    // 对字符串的每个字符，使用 (hash * 33) ^ charCode 的方式更新 hash。
    // 最后通过 hash >>> 0 进行无符号右移，确保返回的哈希值为非负整数。
    var hash = 5381;
    var i = strParams.length;
    while (i) {
        hash = (hash * 33) ^ strParams.charCodeAt(--i);
    }
    return hash >>> 0;
};
var Cache = /** @class */ (function () {
    function Cache(timeout) {
        this.timeout = timeout;
        this.store = {};
    }
    Cache.prototype.isExpired = function (timestamp) {
        return new Date().getTime() - timestamp > this.timeout;
    };
    Cache.prototype.get = function (key) {
        var data = this.store[key];
        if (data === undefined) {
            return undefined;
        }
        var timestamp = data.timestamp, value = data.value;
        if (this.isExpired(timestamp)) {
            this.delete(key);
            return undefined;
        }
        return value;
    };
    /**
     * @description: 存在并且未过期返回返回 false
     */
    Cache.prototype.set = function (key, options) {
        if (!this.get(key)) {
            this.store[key] = {
                value: options === null || options === void 0 ? void 0 : options.value,
                timestamp: new Date().getTime(),
            };
            return true;
        }
        return false;
    };
    Cache.prototype.delete = function (key, delayTime) {
        var _this = this;
        if (delayTime === void 0) { delayTime = 0; }
        return new Promise(function (resolve) {
            setTimeout(function () {
                delete _this.store[key];
                resolve(true);
            }, delayTime);
        });
    };
    Cache.prototype.clear = function () { };
    return Cache;
}());

/**
 * @Author  : zhouming
 * @Date    : 2024-01-11 19:09:55
 * @页面名称    :
 * @页面描述    :
 */
var basicMapping = {
    '[object Array]': 'array',
    '[object Boolean]': 'boolean',
    '[object Date]': 'date',
    '[object Error]': 'error',
    '[object Function]': 'function',
    '[object Number]': 'number',
    '[object Object]': 'object',
    '[object RegExp]': 'regexp',
    '[object String]': 'string',
    '[object Null]': 'null',
};
var hasOwn = Object.prototype.hasOwnProperty;
/**
 * 相等判断适用于对象和原始类型
 * @param {any} x
 * @param {any} y
 */
var is = function (x, y) {
    // === 严格判断适用于对象和原始类型。但是有个例外，就是NaN和正负0。
    if (x === y) {
        // 这个是个例外，为了针对0的不同，譬如 -0 === 0 : true
        // (1 / x) === (1 / y)这个就比较有意思，可以区分正负0, 1 / 0 : Infinity, 1 / -0 : -Infinity
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    }
    // 这个就是针对上面的NaN的情况
    return x !== x && y !== y;
};
/**
 * @description: 类型判断函数
 * @param {any} param
 * @return {string}
 */
var judgeType = function (param) {
    return typeof param === 'object' || typeof param === 'function'
        ? basicMapping[Object.prototype.toString.call(param)] || 'object'
        : typeof param;
};
/**
 * @description: 对象的浅比较函数
 * @param {object} objA
 * @param {object} objB
 * @return {object}
 */
var objectShallowEqual = function (objA, objB) {
    var objAType = judgeType(objA);
    var objBType = judgeType(objB);
    if (objAType !== 'object' || objBType !== 'object') {
        throw new Error('shallowEqual 只处理严格 object 的对象类型');
    }
    var sameAnswer = {
        isEqual: true,
    };
    var differentAnswer = {
        isEqual: false,
        differentKeyList: [],
    };
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        throw new TypeError('objectShallowEqual 函数只处理对象');
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return differentAnswer;
    }
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
            differentAnswer.differentKeyList.push(keysA[i]);
        }
    }
    var length = differentAnswer.differentKeyList.length;
    return length ? differentAnswer : sameAnswer;
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var localDevLog = function () {
    var msg = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        msg[_i] = arguments[_i];
    }
    if (process.env.NODE_ENV === 'development') {
        var groupName = get(msg, '[0]', '') || '';
        console === null || console === void 0 ? void 0 : console.groupCollapsed.apply(console, __spreadArray([groupName.length < 50 ? groupName : "".concat(groupName === null || groupName === void 0 ? void 0 : groupName.slice(0, 50), "...")], ((msg === null || msg === void 0 ? void 0 : msg.slice(1)) || []), false));
        console.log.apply(console, msg);
        console === null || console === void 0 ? void 0 : console.groupEnd();
    }
};

// 缓存最大有效时长 ms
var timeout = 10000;
/**
 * @description:
 * axios.getAdapter 需要版本 >= 1.5.0
 *
 * axios.defaults.adapter
 * 0.15.0 版本开始支持(所以可以认为 npm 包上肯定存在)
 * <1.2.0 直接返回了 adapter,是函数
 * 1.2.0-1.6.7 开始返回字符串数组
 * 并且在 1.1.0-1.1.1 版本又未导出 defaults(这是一个bug,在 https://github.com/axios/axios/pull/5162 修复,只影响 cjs 环境)
 *
 * 1.4.0 开始导出 unsafe - /lib/adapters/http.js 和 /lib/adapters/xhr.js
 * 1.5.0 增加了不带 unsafe 的导出
 */
var cacheInstance = new Cache(timeout);
function getDefaultAdapter() {
    var _a, _b;
    var adapter;
    if (typeof ((_a = axios === null || axios === void 0 ? void 0 : axios.defaults) === null || _a === void 0 ? void 0 : _a.adapter) === 'function') {
        adapter = axios.defaults.adapter;
    }
    else if (typeof (axios === null || axios === void 0 ? void 0 : axios.getAdapter) === 'function' && ((_b = axios === null || axios === void 0 ? void 0 : axios.defaults) === null || _b === void 0 ? void 0 : _b.adapter)) {
        adapter = axios.getAdapter(axios.defaults.adapter);
    }
    return adapter;
}
/**
 * @description: 处理 axios 实例的请求
 */
var adapterEnhancer = function (options) {
    var _a = options || {}, _b = _a.enabledByDefault, enabledByDefault = _b === void 0 ? true : _b, 
    // defaultCache = MemorCache
    _c = _a.adapter, 
    // defaultCache = MemorCache
    adapter = _c === void 0 ? getDefaultAdapter() : _c, _d = _a.repeatResolve, repeatResolveGlobal = _d === void 0 ? true : _d;
    // 处于服务端渲染模式
    var inServeMode = typeof window === 'undefined';
    // 触发 axios 默认逻辑
    if (!adapter || inServeMode || enabledByDefault === false) {
        return null;
    }
    return function (config) {
        var url = config.url, method = config.method, 
        // data` 是作为请求体被发送的数据仅适用 'PUT', 'POST', 'DELETE 和 'PATCH' 请求方法
        data = config.data, forceUpdate = config.forceUpdate, headers = config.headers, _a = config.repeatResolve, repeatResolve = _a === void 0 ? repeatResolveGlobal : _a, _b = config.delayTime, delayTime = _b === void 0 ? 0 : _b;
        // 检查请求头 'Content-Type' 是否为 'application/json'
        var contentType = headers['Content-Type'] || headers['content-type'];
        var isJsonRequest = contentType && contentType.toLowerCase().startsWith('application/json');
        if (method === 'get' || forceUpdate || !isJsonRequest) {
            // 使用默认的 xhrAdapter 发送请求
            return adapter(config);
        }
        var argStr = JSON.stringify({ url: url, data: data });
        var hashKey = hash(argStr);
        var inCache = !!cacheInstance.get(hashKey);
        if (inCache) {
            console.log("\u672C\u6B21\u8BF7\u6C42\u547D\u4E2D\u7F13\u5B58,\u8BF7\u6C42\u53C2\u6570\u662F".concat(argStr));
            if (repeatResolve) {
                return cacheInstance.get(hashKey);
            }
            return new Promise(function () { });
        }
        else {
            var responsePromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
                var reason_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, adapter(config).then(function (res) {
                                    cacheInstance.delete(hashKey, delayTime);
                                    return res;
                                })];
                        case 1: 
                        // 使用默认的xhrAdapter发送请求
                        return [2 /*return*/, _a.sent()];
                        case 2:
                            reason_1 = _a.sent();
                            // 增加功能: 重试请求或返回默认值
                            cacheInstance.delete(hashKey, 0);
                            throw reason_1;
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
            // 保存请求返回的响应对象
            cacheInstance.set(hashKey, { value: responsePromise });
            // 返回已保存的响应对象
            return responsePromise;
        }
    };
};
/**
 * @description: 处理非 axios 实例的请求
 */
var postEnhancer = function (originPost) {
    return function (url, params, config) {
        // 处于服务端渲染模式
        var inServeMode = typeof window === 'undefined';
        var _a = config || {}, _b = _a.forceUpdate, forceUpdate = _b === void 0 ? false : _b, _c = _a.repeatResolve, repeatResolve = _c === void 0 ? true : _c, _d = _a.delayTime, delayTime = _d === void 0 ? 0 : _d;
        // 检查 params 是否为 JSON 格式的数据
        var isJsonRequest = typeof params === 'object' && !(params instanceof FormData);
        if (inServeMode || forceUpdate || !isJsonRequest) {
            return originPost(url, params, config);
        }
        var argStr = JSON.stringify({ url: url, params: params });
        var hashKey = hash(argStr);
        var inCache = !!cacheInstance.get(hashKey);
        if (inCache) {
            console.log("\u672C\u6B21\u8BF7\u6C42\u547D\u4E2D\u7F13\u5B58,\u8BF7\u6C42\u53C2\u6570\u662F".concat(argStr));
            if (repeatResolve) {
                return cacheInstance.get(hashKey);
            }
            return new Promise(function () { });
        }
        else {
            var responsePromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
                var reason_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, originPost(url, params, config).then(function (res) {
                                    cacheInstance.delete(hashKey, delayTime);
                                    return res;
                                })];
                        case 1: return [2 /*return*/, _a.sent()];
                        case 2:
                            reason_2 = _a.sent();
                            cacheInstance.delete(hashKey, 0);
                            throw reason_2;
                        case 3: return [2 /*return*/];
                    }
                });
            }); })();
            // 保存请求返回的响应对象
            cacheInstance.set(hashKey, { value: responsePromise });
            // 返回已保存的响应对象
            return responsePromise;
        }
    };
};

exports.Cache = Cache;
exports.HostHabo = HostHabo;
exports.adapterEnhancer = adapterEnhancer;
exports.hash = hash;
exports.is = is;
exports.judgeType = judgeType;
exports.localDevLog = localDevLog;
exports.objectShallowEqual = objectShallowEqual;
exports.postEnhancer = postEnhancer;
//# sourceMappingURL=index.cjs.map
